import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import { ACL } from "src/components/acl";
import { Subheading } from "src/components/base/heading";
import { useTranslation } from "react-i18next";
import SINGLE_SUBNET_CONTEXT from "src/context/internal/subnet";
import ReadOnlyRuleSets from "src/components/rulesets";

/**
 * The properties for {@link SubnetInboundACLs}
 */
export type SubnetInboundACLsProps = {};

/**
 * The view to display the Inbound ACLs of a tag
 */
function SubnetInboundACLs(props: SubnetInboundACLsProps) {
    const [t] = useTranslation("admin-subnet-view");

    const ctx = React.useContext(SINGLE_SUBNET_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            <Subheading>{t("heading.add-new-acl")}</Subheading>
            <ACL
                key={"new-inbound"}
                onChange={ctx.reset}
                dst={{ type: "Subnet", value: ctx.subnet }}
                startEditable={true}
            />

            <Subheading>{t("heading.existing-acls")}</Subheading>
            {ctx.subnet.access_rules.inbound.map((acl) => (
                <ACL key={acl.uuid} dst={acl.dst} acl={acl} onChange={ctx.reset} />
            ))}

            <Subheading>{t("heading.rulesets")}</Subheading>
            {ctx.subnet.rulesets.inbound.map((ruleset) => (
                <ReadOnlyRuleSets
                    key={ruleset.uuid}
                    name={ruleset.name}
                    description={ruleset.description}
                    rules={ruleset.rules}
                    destinations={ruleset.src_or_dst}
                />
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/subnets/$subnetId/_subnet/inbound-acls")({
    component: SubnetInboundACLs,
});
